import { AssetMasterModule } from "@/store/modules/asset.module";
import { toaster } from "@/utilities/toaster";
import { Guid } from "guid-typescript";
import { Machine } from "xstate";
const editAssetMachine = Machine({
    id: "editAsset",
    context: {
        assetId: Guid.createEmpty(),
    },
    initial: "idle",
    states: {
        idle: {
            always: [{ target: "gettingEditAssetsDetails" }],
        },
        gettingEditAssetsDetails: {
            invoke: {
                id: "gettingEditAssetsDetails",
                src: (context, event) => AssetMasterModule.GetAssetDetails(context.assetId),
                onDone: { target: "loadedEditAssets" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedEditAssets: {
            on: {
                CHANGE_STATUS: { target: "changeStatus" },
                SENT_FOR_REPAIR: { target: "sentRepairStatus" },
                UPDATE_ASSET: { target: "updateAsset" },
                CANCEL_EDIT_ASSET: { target: "cancelEditAsset" },
                RECEIVED_FROM_REPAIR: { target: "receivedRepairStatus" },
            },
        },
        sentRepairStatus: {
            on: {
                SAVE_REPAIR_NOTES_BEFORE_SERVICE: { target: "loadedEditAssets" },
                CANCEL_REPAIR_NOTES_BEFORE_SERVICE: { target: "loadedEditAssets" },
            },
        },
        receivedRepairStatus: {
            on: {
                SAVE_REPAIR_NOTES_AFTER_SERVICE: { target: "loadedEditAssets" },
                CANCEL_REPAIR_NOTES_AFTER_SERVICE: { target: "loadedEditAssets" },
            },
        },
        changeStatus: {
            on: {
                CONFIRM_STATUS_CHANGE: { target: "loadedEditAssets" },
                CANCEL_CONFIRM_STATUS: { target: "loadedEditAssets" },
            },
        },
        updateAsset: {
            invoke: {
                id: "updateAsset",
                src: (context, event) => {
                    return AssetMasterModule.UpdateAsset(event.payload);
                },
                onDone: { target: "gettingListAssetsDetails", actions: ["showSuccessMessage"] },
                onError: { target: "gettingEditAssetsDetails" },
            },
        },
        gettingListAssetsDetails: {
            on: {
                UPDATED_ASSET_LIST: { target: "gettingListAssetsDetails" },
            },
        },
        cancelEditAsset: {
            on: {
                CANCEL_EDIT_ASSET: { target: "loadedEditAssets" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
    },
    guards: {},
    activities: {},
    services: {},
});
export default editAssetMachine;
